module.exports = {
  "$id": "agentUser",
  "type": "object",
  "title": "代理人注册",
  "properties": {
    "registerAgentUserInfo": {
      "title": "代理用户",
      "type": "object",
      "properties": {
        "login": {
          "title": "用户名",
          "type": "string",
          "format": "loginName"
        },
        "password": {
          "title": "密码",
          "type": "string",
          "format": "password"
        },
        "confirmPassword": {
          "title": "确认密码",
          "type": "string",
          "format": "password",
          "const": {
            "$data": "1/password"
          }
        },
        "phone": {
          "title": "手机号",
          "type": "string",
          "customValidate": "mobile"
        },
        "areaCode": {
          "title": "区位码",
          "type": "string"
        },
        "email": {
          "title": "邮箱",
          "type": "string",
          "format": "email"
        },
        "chiSurname": {
          "title": "中文姓",
          "type": "string",
          "customValidate": "zhLastName"
        },
        "chiName": {
          "title": "中文名",
          "type": "string",
          "customValidate": "zhFirstName"
        },
      },
      "required": [
        "login",
        "chiSurname",
        "chiName"
      ]
    }
  },
  "required": [
    "registerAgentUserInfo"
  ],
  "errorMessage": {
    "registerAgentUserInfo.login": {
      "message": "请输入用户名,长度6-40位",
      "required": "用户名不能为空"
    },
    "registerAgentUserInfo.password": {
      "message": "请输入密码,8位-20位",
      "required": "密码不能为空"
    },
    "registerAgentUserInfo.confirmPassword": {
      "message": "两次密码输入不一致！",
      "pattern": "请输入密码,8位-20位",
      "required": "请再次输入密码"
    },
    "registerAgentUserInfo.phone": {
      "required": "手机号码不能为空"
    },
    "registerAgentUserInfo.email": {
      "message": "请输入正确的电子邮箱",
      "required": "电子邮箱不能为空"
    },
    "registerAgentUserInfo.chiSurname": {
      "required": "中文姓不能为空"
    },
    "registerAgentUserInfo.chiName": {
      "required": "中文名不能为空"
    }
  }
}
